import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@adsk/bim360-matrix-react-components';
import { connect } from '../../redux/connect';
import * as selectors from '../../redux/selectors';
import { RFIsRouterContext } from '../../redux/RFIsContext';
import { childrenType } from '../../constants/proptype-validation';
import { POPUP_VIEWER_URL, POPUP_VIEWER_TITLE } from '../../constants/common';
import NotificationManager from './components/NotificationManager';
import IFrameModalWithCallbacks from './components/IFrameModalWithCallbacks';
import '../../assets/styles/app.scss';

export const PureBaseComponent = (props) => {
  const {
    isMandatoryAppDataLoading,
    isFFLoaded,
    disabled,
    disableNotifications,
    onIframeOpen,
    onIframeClose,
    children,
  } = props;
  const { history, location } = useContext(RFIsRouterContext);

  if (isMandatoryAppDataLoading || !isFFLoaded) {
    return <Loader />;
  }

  return (
    <div className="rfis-root-element">
      {children}
      {!disabled && !disableNotifications && <NotificationManager />}
      {!disabled && (
        <IFrameModalWithCallbacks
          router={history}
          location={location}
          iframeSourceUrlParameter={POPUP_VIEWER_URL}
          iframeTitleUrlParameter={POPUP_VIEWER_TITLE}
          onIframeOpen={onIframeOpen}
          onIframeClose={onIframeClose}
        />
      )}
    </div>
  );
};

PureBaseComponent.propTypes = {
  children: childrenType.isRequired,
  isFFLoaded: PropTypes.bool.isRequired,
  isMandatoryAppDataLoading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  disableNotifications: PropTypes.bool,
  onIframeOpen: PropTypes.func,
  onIframeClose: PropTypes.func,
};

PureBaseComponent.defaultProps = {
  disabled: false,
  disableNotifications: false,
  onIframeOpen: () => {},
  onIframeClose: () => {},
};

PureBaseComponent.displayName = 'BaseComponent';

const mapStateToProps = (state) => ({
  isFFLoaded: selectors.isFFLoaded(state),
  isMandatoryAppDataLoading: selectors.isMandatoryAppDataLoading(state),
});

export default connect(mapStateToProps)(PureBaseComponent);
